
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learning-areas/[learningarea]/[syllabus]/overview/[section]",
      function () {
        return require("private-next-pages/learning-areas/[learningarea]/[syllabus]/overview/[section]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learning-areas/[learningarea]/[syllabus]/overview/[section]"])
      });
    }
  